import { ThemeProvider } from "@mui/material/styles";
import { type ReactElement, type ReactNode } from "react";

import { getRebrandTheme } from "./rebrandTheme";

const rebrandTheme = getRebrandTheme("light");

interface Props {
  children: ReactNode;
}

/**
 * @deprecated Use `BerlinThemeProvider` from `@src/appV2/redesign/theme/ThemeProvider`
 * instead. This provider mounts the legacy MUI theme, whose breakpoints, spacing,
 * palette, typography, and component overrides diverge from the current design system.
 */
export function MuiThemeProvider(props: Props): ReactElement {
  const { children } = props;

  return <ThemeProvider theme={rebrandTheme}>{children}</ThemeProvider>;
}
